import { centsToDollars, numberToString } from '@marmon/shared/types/common';
import { ExportType } from '../interfaces';

/**
 * Removes harmful characters from the value
 *
 * @param value The value to sanitize
 * @returns the new safe value
 */
export function sanitizeValue(value: any) {
	if (value == null) return '';
	if (typeof value !== 'string') value = '' + value;

	return value
		.replace(/#/g, '')
		.replace(/(\r\n|\n|\r|\s+|\t|&nbsp;)/gm, ' ')
		.replace(/"/g, '""')
		.replace(/ +(?= )/g, '')
		.replace(/,/g, ' ')
		.trim();
}

/**
 * Strips the html tags out of the provided value
 *
 * @param value The value to strip the html from
 * @returns The stripped out html value
 */
export function stripHtml(value: any) {
	if (value == null) return '';
	if (typeof value !== 'string') value = '' + value;

	/**
	 * Regular expression to identify HTML tags in
	 * the input string. Replacing the identified
	 * HTML tag with a null string.
	 */
	return value.replace(/(<([^>]+)>)/gi, '');
}

/**
 * Includes sanitizing the values for csv safe exporting
 *
 * @param key provide the key to determine some preset formatting that are key specific
 * @param value the value to format
 */
export function formatter(key: string, value: any) {
	if (value == null) return sanitizeValue('-');

	key = key.toLowerCase();
	// common use cases for additional configurations
	if (key.includes('incents')) {
		return centsToDollars((value as number) ?? 0);
	} else if (key.includes('percent')) {
		return numberToString((value as number) ?? 0);
	} else if (value instanceof Date) {
		return sanitizeValue(
			value.toLocaleDateString('en-US', { timeZone: 'utc' }),
		);
	} else if (value.toString) {
		// catch all for some objects that may support stringify
		return sanitizeValue(value.toString());
	}

	switch (typeof value) {
		case 'string':
			return sanitizeValue(value ?? '');
		case 'number':
			return sanitizeValue(value ?? 0);
		case 'boolean':
			return sanitizeValue(value ? 'True' : 'False');
		default:
			return sanitizeValue('-');
	}
}

export const ExportName = (type: ExportType): string => {
	return {
		customersBreakdown: 'CustomerOpportunities',
		productsBreakdown: 'ProductOpportunities',
		customers: 'QuartileTableCustomers',
		products: 'QuartileTableProducts',
		invoices: 'QuadTableInvoices',
	}[type];
};
